module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/electric/outlet-bee7b58ec72dc23d6e5df0350cc83f69.svg";